<template>
  <div class="page-container">
    <div id="loading-panel">
      <img class="logo" src="../../static/img/loading.png" alt=""/>
      <p >
        <span :style="{width:percent}"></span>
      </p>
      <h2><strong>{{percent}}</strong></h2>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
    return {
      count: 0,
      percent: '',
      imgLength:''
    }
  },
  mounted: function() {
    this.preload()
  },
  methods: {
    preload: function() {
      let imgs = [
        "static/img/back.png",
        "static/img/begin.png",
        "static/img/boat.png",
        "static/img/cfdq-name.png",
        "static/img/cfdq-tl.png",
        "static/img/cfdq.png",
        "static/img/cover1.png",
        "static/img/cover2.png",
        "static/img/cover3.png",
        "static/img/cover4.png",
        "static/img/gjk-name.png",
        "static/img/gjk-tl.png",
        "static/img/gjk.png",
        "static/img/hpjmt-name.png",
        "static/img/hpjmt-tl.png",
        "static/img/hpjmt.png",
        "static/img/intro.png",
        "static/img/jnsx-name.png",
        "static/img/jnsx-tl.png",
        "static/img/jnsx.png",
        "static/img/loading.png",
        "static/img/location.png",
        "static/img/mus-stop.png",
        "static/img/music.png",
        "static/img/page0-bg.jpg",
        "static/img/page0-btn.png",
        "static/img/page0-intro.png",
        "static/img/page1-bg.jpg",
        "static/img/page2-bg.jpg",
        "static/img/phone.png",
        "static/img/product.png",
        "static/img/screen1.png",
        "static/img/screen2.png",
        "static/img/shj-name.png",
        "static/img/shj-tl.png",
        "static/img/shj.png",
        "static/img/spdq-name.png",
        "static/img/spdq-tl.png",
        "static/img/spdq.png",
        "static/img/stld-name.png",
        "static/img/stld-tl.png",
        "static/img/stld.png",
        "static/img/szh-name.png",
        "static/img/szh-tl.png",
        "static/img/szh.png",
        "static/img/tcgx-name.png",
        "static/img/tcg-tl.png",
        "static/img/tcg.png",
        "static/img/theme.png",
        "static/img/wsjdq-name.png",
        "static/img/wsjdq-tl.png",
        "static/img/wsjdq.png",
        "static/img/wxfx.png",
        "static/img/yqg-name.png",
        "static/img/yqg-tl.png",
        "static/img/yqg.png",       
      ]
      this.imgLength=imgs.length
//      console.log(this.imgLength)
      for (let img of imgs) {
        let image = new Image()
        image.src = img
        image.onload = () => {
          this.count++
          // 计算图片加载的百分数，绑定到percent变量
          let percentNum = Math.floor(this.count / this.imgLength * 100)
          this.percent = `${percentNum}%`
        }
      }
    },

  },

  watch: {
    count: function(val) {
//      console.log(val)
      if (val ==this.imgLength) {
        // 图片加载完成后跳转页面
        this.$router.push({path: '/page0'})
      }
    }
  }
  }
</script>
<style>
  .page-container{
    width: 100%;
    height: 100%;
    position:absolute;
    top:0;
    left:0;
    /*background:#e9ded0;*/
    background:#e4d9bb;
    overflow: hidden;
  }
  #loading-panel .logo{
    width: 20%;
    position:absolute;
    top:35%;
    left:40%;
    animation-name: bounceLogo;
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
    transform-origin: center bottom;
  }
  #loading-panel p{
    width: 80%;
    height: 1.5%;
    border: 1px solid #000;
    position:absolute;
    top:50%;
    left:10%;
    border-radius: 30px;
    overflow: hidden;
  }
  #loading-panel p span{
    position: absolute;
    top:0;
    left:0;
    width: 50%;
    height: 100%;
    background:red;
  }
  #loading-panel h2{
    position: absolute;
    top:53%;
    left:43%;
  }
  @keyframes bounceLogo {
    from, 20%, 80%, to {
      animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
      transform: translate3d(0, 0, 0) scale3d(1, 1, 1);
    }

    53% {
      animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
      transform: translate3d(0, 0, 0) scale3d(1.15, 0.85, 1);
    }

    40%, 43% {
      animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
      transform: translate3d(0, -20px, 0) scale3d(1, 1, 1);
    }

    70% {
      animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
      transform: translate3d(0, -10px, 0) scale3d(1, 1, 1);
    }

    90% {
      transform: translate3d(0, -3px, 0) scale3d(1, 1, 1);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/loading.vue